import styled from "styled-components";

export const LiveStreamingTileDefaultBox = styled.div`
    position: relative;
    width: 100%;
    overflow: hidden;
    box-shadow: ${props => props.theme.colors.buttonDark} 0px 10px 8px -6px;

    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        border-radius: 12px;
        border: 0.5px solid ${props => props.theme.components.newLiveCasino.colors.gridItem.wrapperBorder};
    }

    @media ${({theme}) => `${theme.mediaQuery.lAndBelow} and ${theme.mediaQuery.landscape}`} {
        padding: 0 12.5vw;
    }

    @media ${({theme}) => `${theme.mediaQuery.mAndBelow} and ${theme.mediaQuery.landscape}`} {
        padding: 0 25vw;
    }
`;